"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var savant_listing_1 = require("savant-listing");
var response_1 = require("../../connector/response");
var useClientFiltersWithOptions = function (data, filterOptions) {
    var _a = filterOptions.filters, filters = _a === void 0 ? [] : _a;
    return savant_listing_1.useClientFiltering(data, filters);
};
var useNextTokenPagingWithOptions = function (data, pageLoading, error, nextPage, options) {
    var prefetchPages = (options && options.prefetchPages) || 0;
    var _a = savant_listing_1.useListingContext().paging, pageSize = _a.pageSize, pageNumber = _a.pageNumber;
    // The number of items that we need to show a pageful of data for our current client page
    // We need the +1 at the end because the way client paging works we only enable the next page
    // callback if there is is more data beyond our current page.
    var desiredItems = (pageNumber + 1) * pageSize + 1;
    // We're in a loading state if all of the following are true:
    //  * we don't have the desired number of items.
    //  * we aren't in an error (we don't request any more data in this case)
    //  * The paginated query is in a loading state OR there is a nextPage callback we can call
    var loading = !!(data.length < desiredItems &&
        !error &&
        (pageLoading || nextPage));
    // Request the next page if we want more data, and we're not already loading data
    React.useEffect(function () {
        var hasNextPage = !pageLoading && !error && nextPage;
        var prefetchItems = pageSize * prefetchPages;
        if (hasNextPage && data.length < desiredItems + prefetchItems) {
            nextPage();
        }
    }, [prefetchPages, desiredItems, data, pageLoading, error]);
    return {
        loading: loading,
    };
};
function useListingContextServerConsumer(paginatedQuery, options) {
    var _a = (options || {}).filtering, filtering = _a === void 0 ? {} : _a;
    var response = paginatedQuery.response, error = paginatedQuery.error, pageLoading = paginatedQuery.loading, nextPage = paginatedQuery.nextPage, refresh = paginatedQuery.refresh;
    var data = response_1.getListResponseData(response);
    var filtered = useClientFiltersWithOptions(data, filtering);
    var loading = useNextTokenPagingWithOptions(filtered, pageLoading, error, nextPage, options && options.paging).loading;
    // re-assign for easy consumption without polluting the hooks with garbage names
    var _b = savant_listing_1.useClientPaging(filtered, { allowOutOfBounds: loading }), page = _b.page, currentPage = _b.currentPageNumber, onNext = _b.goToNextPage, onPrevious = _b.goToPreviousPage;
    return {
        loading: loading,
        error: error,
        page: page,
        refresh: refresh,
        pagination: {
            currentPage: currentPage,
            onNext: onNext,
            onPrevious: onPrevious,
        },
    };
}
exports.default = useListingContextServerConsumer;
//# sourceMappingURL=useListingContextServerConsumer.js.map